import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './assets/styles/productCards.css'

// Import global product functions for console access
import './utils/createProducts'

// Initialize authentication service
import './services/authService'

// Import test user utilities for console access
import './utils/createTestUser'

loadFonts()

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
